var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news-index-page--template page-template" }, [
    _c("div", { staticClass: "bg clouds-top-right" }),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid relative" }, [
      _c("section", { staticClass: "mw7 relative z-1 center pv4 pv5-ns" }, [
        _c("div", { staticClass: "bg ski-dancer" }),
        _vm._v(" "),
        _c("div", { staticClass: "tc" }, [
          _c("h1", { staticClass: "page-title pt4" }, [
            _vm._v(_vm._s(_vm.page.title))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "absolute z-0 mw4 mw5-ns topography topography-top-left-wrap"
        },
        [
          _c("simple-svg", {
            attrs: {
              filepath: "/assets/images/svg/gdz18-topography.svg",
              id: "topography-top-left"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid relative" },
      [
        _vm._l(_vm.posts, function(post, index) {
          return index < 1
            ? _c(
                "section",
                { staticClass: "mw7 relative z-1 center mv2 mv3-ns" },
                [
                  post["Featured Image"]
                    ? _c("img", {
                        staticClass: "db relative center content-image",
                        attrs: { src: post["Featured Image"] }
                      })
                    : _c("img", {
                        staticClass: "db relative center content-image",
                        attrs: { src: "/uploads/gdz18-news-hero.jpg" }
                      }),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass:
                        "is-interstate-black ttu tc lh-title pointer cream-bg mh--1"
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "db f3 f2-ns pa2 pa3-ns no-underline pointer is-red",
                          attrs: { to: post.url }
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(post.title) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "db relative center pv3 pa4-ns bg-light-blue-ns is-purple"
                    },
                    [
                      _c("p", {}, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("truncate")(post.Excerpt, 100)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "ttu link is-red pointer",
                          attrs: { to: post.url }
                        },
                        [_vm._v("+ View More")]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "absolute z-0 topography topography-bottom-right-wrap"
          },
          [
            _c("simple-svg", {
              attrs: {
                filepath: "/assets/images/svg/gdz18-topography.svg",
                id: "topography-bottom-right"
              }
            })
          ],
          1
        )
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid relative" }, [
      _c("section", { staticClass: "mw8 relative z-1 center mv4 mv5-ns" }, [
        _c(
          "div",
          { staticClass: "row mb4" },
          _vm._l(_vm.posts, function(post, index) {
            return index > 0
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 ph2-ns mv2 mv3-ns" },
                  [
                    post["Featured Image"]
                      ? _c("img", {
                          staticClass:
                            "db relative center news-secondary-image content-image",
                          attrs: { src: post["Featured Image"] }
                        })
                      : _c("img", {
                          staticClass:
                            "db relative center news-secondary-image content-image",
                          attrs: { src: "/uploads/gdz18-news-thumb3.jpg" }
                        }),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "content-title mv0 ttu tc cream-bg mh1" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "db f4 f3-ns pa2 pv3-ns ph1-ns no-underline pointer is-red",
                            attrs: { to: post.url }
                          },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(post.title) +
                                  "\n                "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "db relative center w-80 pv3 pa4-ns bg-light-blue-ns f5 is-purple"
                      },
                      [
                        _c("p", {}, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("truncate")(post.Excerpt, 100)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "ttu link is-red pointer",
                            attrs: { to: post.url }
                          },
                          [_vm._v("+ View More")]
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bg plus-signs" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }